module.exports = __webpack_public_path__ + "static/time-d77eb6b97ff634840b548d9856c1a598.svg";